import { render, staticRenderFns } from "./AuditUsers.vue?vue&type=template&id=4b41a492&"
import script from "./AuditUsers.vue?vue&type=script&lang=js&"
export * from "./AuditUsers.vue?vue&type=script&lang=js&"
import style0 from "./AuditUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b41a492')) {
      api.createRecord('4b41a492', component.options)
    } else {
      api.reload('4b41a492', component.options)
    }
    module.hot.accept("./AuditUsers.vue?vue&type=template&id=4b41a492&", function () {
      api.rerender('4b41a492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/AuditUsers.vue"
export default component.exports